import classNames from "classnames";
import moment from "moment";

import { useContext, useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import EmailService from "api/emailService";
import listService from "api/listService";
import tagsService from "api/tagsService";
import DirectionIcon from "assets/icons/msg_incoming.svg?react";
import Avatar from "components/Avatar";
import IconsState from "components/IconsState";
import ModalLayout, { DockPosition } from "components/ModalLayout";
import OptionsCard from "components/OptionsCard/OptionsCard";
import SecondCheckbox from "components/SecondCheckbox";
import StatusBadge from "components/StatusBadge";
import StatusModal from "components/StatusModal";
import TagBadge from "components/TagBadge";
import { IAttachment } from "dto/IAttachment";
import { ItemKind } from "dto/IKindItems";
import { IStatus } from "dto/IStatus";
import { ITag } from "dto/ITag";
import GroupIcon from "assets/icons/groups.svg?react";
import { decryptPackage } from "utils/decryptPackage";
import { getUserId } from "utils/getUserId";
import { useAuth } from "react-oidc-context";
import PackagesContext from "contexts/PackagesContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faEllipsis,
  faEllipsisVertical,
} from "@fortawesome/free-solid-svg-icons";
import MenuContext from "contexts/MenuContext";
import { addToUrl, parseHTML } from "utils/parseHTML";
import { sanitizeUserHtml } from "utils/sanitizeUserHtml";
import { decodeAndFetchImages } from "utils/decodeAndFetchImages";
import { getKeys } from "utils/getKeys";
import { useNavigate, useParams } from "react-router";
import CasesContext from "contexts/CasesContext";
import { IKey } from "dto/IKey";
import PackageReceiversModal from "components/PackageReceiversModal";
import PackageAttachment from "components/PackageAttachment";
import Popper from "components/Popper";
import AttachToCaseModalAttachments from "components/AttachCaseModalNew/AttachToCaseModalAttachments";
import { IAttachToCaseFolderLink } from "api/casesService";
import settingsContext, { IOptionType } from "contexts/SettingsContext";
import MetricDatesModal from "components/MetricDatesModal";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const ChatCard: FC<Props> = ({
  handleChangePackages,
  editMode = false,
  isSelected = false,
  Package: pack,
  statuses,
  tags,
  keys,
  onDownload,
  onPreview,
  setPack,
  forceExpanded,
  grow,
  contactMessageChatId,
  showReceiver = true,
  showTools = true,
  isMobile = false,
}) => {
  const { t } = useTranslation();
  const { caseId } = useParams();
  const auth = useAuth();
  const refWrapper = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(!!forceExpanded);
  const [showFullContent] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [showReceivers, setShowReceivers] = useState(false);
  const [status, setStatus] = useState<IStatus | null>(null);
  const [findedTags, setFindedTags] = useState<ITag[]>([]);
  const { mutate: removeTag } = tagsService.useRemoveTagFromPackage();
  const [showFlags, setShowFlags] = useState(false);
  const statusRef = useRef(null);
  const [showCcReceivers, setShowCcReceivers] = useState(false);
  const receiversReference = useRef(null);
  const singleReceiverRef = useRef(null);
  const receiversCcReference = useRef(null);

  const [showDateMetric, setShowDateMetic] = useState<boolean>(false);
  const dateRef = useRef();

  const [attachmentsLocation, setAttachmentsLocation] =
    useState<string>("center");

  const { options } = useContext(settingsContext);

  useEffect(() => {
    if (options) {
      const attL = options.find(
        (x) => x.Type === IOptionType.caseAttachAttachmentsLocation,
      );

      if (attL) {
        setAttachmentsLocation(attL.Value);
      }
    }
  }, [options]);

  const [showDossier, setShowDossier] = useState<boolean>(false);
  const [usedAttachments, setUsedAttachments] = useState<
    IAttachToCaseFolderLink[]
  >([]);
  const [unusedAttachments, setUnusedAttachments] = useState<IAttachment[]>([]);

  const { cases } = useContext(CasesContext);

  const Case = cases.find((c) => c.Id === caseId);

  const canEdit =
    auth?.user?.profile?.role === "guest" ? Case?.Privileges === 2 : true;

  const [content, setContent] = useState("");

  const { data: previewData } = EmailService.useGetPreview(
    pack.Id ?? "",
    showFullContent,
    pack?.Kind === ItemKind.Email && expanded ? true : false,
  );

  const userId = getUserId(auth.user!);

  const decodeEncryptedContent = async (contactMessageChatId?: string) => {
    await getKeys(userId!, contactMessageChatId);
    const objectKey = previewData?.data?.ObjectKeys?.[0];

    let parentKey = null;

    if (objectKey?.ParentKeyId) {
      parentKey = previewData?.data?.Keys.find(
        (k: IKey) => k?.Id === objectKey.ParentKeyId,
      );
    }

    const content = await decryptPackage(
      userId,
      previewData?.data?.Content ?? "",
      objectKey,
      parentKey ?? undefined,
      null,
      contactMessageChatId,
    );

    const images = await decodeAndFetchImages(
      userId,
      previewData?.data,
      objectKey!,
      parentKey ?? undefined,
    );

    setContent((await parseHTML(content, images)).content);
  };

  const getContent = async () => {
    console.log("getContent", contactMessageChatId);
    if (pack.Kind === 128) {
      const isEncrypted = previewData?.data?.IsEncrypted;

      if (isEncrypted) {
        // setAllowImages(true);
        decodeEncryptedContent(contactMessageChatId);
        return;
      }
      // const isImages = await hasImages(previewData?.data?.Content);

      // if (!canImages && isImages) {
      // setAllowImages(false);
      // }

      if (!previewData) return;

      setContent(await addToUrl(previewData?.data?.Content, true));

      return;
    }

    if (!pack.EncryptionKeyId && previewData && previewData.data) {
      setContent(previewData?.data?.Content);
      return;
    }

    // typy wiadomości szyfrowanych
    // todo: isEncrypted w IPackage
    if (pack.EncryptionKeyId) {
      try {
        atob(pack.S2);

        if (!keys) {
          return;
        }

        const encryptionKey = keys.find(
          (key) => key?.Id === pack?.EncryptionKeyId,
        );

        let parentKey = null;
        if (encryptionKey?.ParentKeyId) {
          parentKey = keys.find(
            (key) => key?.Id === encryptionKey?.ParentKeyId,
          );
        }

        setContent(
          await decryptPackage(
            userId,
            pack.S2,
            encryptionKey,
            parentKey,
            null,
            contactMessageChatId,
          ),
        );
        return;
      } catch (e) {
        setContent(pack.S2);
        return;
      }
    } else {
      setContent(pack.S2 ?? "");
    }
  };

  const handleAddToDossierClick = () => {
    console.log("adding");
    setUsedAttachments([]);
    setUnusedAttachments(pack.Attachments);
    setShowDossier(true);
  };

  const handleDossierSave = () => {
    manageDossier({
      AttachmentIds: usedAttachments.map((x) => x.AttachmentId),
      OwnerId: pack.Id,
      OwnerKind: pack.Kind,
      Show: true,
      Links: usedAttachments,
    });

    const newPacks = [...packages];

    usedAttachments.forEach((a) => {
      const el = newPacks.find((p) => p.Id === pack.Id);
      if (el) {
        const attach = el.Attachments.find((e) => e.Id === a.AttachmentId);

        if (attach) {
          attach.ShowInDossier = 1;
        }
      }
    });

    setPackages(newPacks);
  };

  useEffect(() => {
    getContent();
  }, [pack, isSelected, keys, previewData, expanded]);

  useEffect(() => {
    const filteredTags = tags?.filter((tag) =>
      pack?.TagIds?.find((iTag) => tag.Id === iTag),
    );

    const newStatus = statuses?.find((s) => s.Id === pack.StatusId);
    setFindedTags(filteredTags);

    setStatus(newStatus ?? null);
  }, [statuses, pack.StatusId]);

  const handleRemoveTag = (tag: ITag) => {
    removeTag(
      {
        OwnerId: pack.Id,
        OwnerKind: pack.Kind,
        TagId: tag.Id,
      },
      {
        onSuccess: () => {
          setFindedTags(findedTags?.filter((ftag) => ftag.Id !== tag.Id));
        },
      },
    );
  };

  const onNewWindow = async (attach: IAttachment) =>
    window.open(
      `${
        import.meta.env.VITE_APP_SITE ?? "https://alfa.pocztaprawnicza.pl"
      }/document?pdf=${pack.Id}:${attach.FileName}:${attach.Uri ?? attach.Id}:${
        pack.Kind
      }:${attach.EncryptionKeyId}`,
    );

  const { mutate: manageDossier } = listService.useManageDossier();

  const { packages, setPackages } = useContext(PackagesContext);

  const { id, setId } = useContext(MenuContext);

  useEffect(() => {
    if (id !== pack.Id) {
      setShowOptions(false);
    }
  }, [id]);

  const navigate = useNavigate();
  const refWrappeer = useRef();
  const packCcReceivers = pack?.Receivers?.filter((x) => x.Cc || x.Bcc);

  // useOnClickOutside(refWrapper, () => {
  //   setShowOptions(false);
  // });

  return (
    <>
      <div
        key={pack.Id}
        ref={refWrapper}
        className={classNames(
          styles.wrapper,
          !pack.IsIncoming && styles.outgoing,
          grow && styles.grow,
        )}
        // onMouseEnter={() => setShowOptions(true)}
        // onMouseLeave={() => setShowOptions(false)}
      >
        {!grow && (
          <div className={styles.direction}>
            <DirectionIcon></DirectionIcon>
          </div>
        )}

        <OptionsCard
          selectedElements={[]}
          binds
          toggle={() => setShowOptions(false)}
          showOptions={showOptions}
          pack={pack}
          refetch={() => {}}
          refWrapper={refWrappeer}
          onClickAttachIcon={() => {}}
          isCase
          isRightClicked
          dropdown
        />
        <div className={styles.checkbox}>
          {editMode && (
            <SecondCheckbox
              value={isSelected}
              onChange={(s) => handleChangePackages?.(pack, s)}
            />
          )}
        </div>
        <div
          className={classNames(
            styles.card,
            expanded && styles.scrollable,
            expanded && styles.expanded,
          )}
        >
          <div className={styles.header}>
            {expanded && (
              <Avatar className={styles.avatar} name={pack.Sender ?? ""} />
            )}
            <div className={styles.rows}>
              <div onClick={() => {}} className={styles.row1}>
                <div className={styles.sender}>
                  {(pack?.Sender ?? "").split("<")[0]}
                </div>
                <div className={styles.date}>
                  <div
                    className={styles.dateWrapper}
                    onClick={() => setShowDateMetic(true)}
                    ref={dateRef}
                  >
                    <Tooltip title={t("tooltips.showDates")}>
                      <div>
                        {moment(pack?.SendDate).format("DD.MM.YYYY").toString()}
                      </div>
                    </Tooltip>
                  </div>

                  {canEdit && showTools && (
                    <div
                      onClick={() => {
                        setShowOptions(!showOptions);
                        setId(pack.Id);
                      }}
                      ref={refWrappeer}
                      className={styles.hover}
                    >
                      <FontAwesomeIcon icon={faEllipsisVertical} />
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.row2}>
                <div
                  className={styles.title}
                  onClick={() => {
                    if (setPack) return;
                  }}
                >
                  {pack?.S1 ?? pack?.S2}
                  {pack?.Kind === ItemKind.CourtPortalApplication &&
                    !pack.S1 &&
                    t("edelivery.request")}
                  {pack?.Kind === ItemKind.ContactMessage &&
                    !pack.S1 &&
                    t("chat.encryptedMessage")}
                </div>
                <div className={styles.icons}>
                  {!isMobile && (
                    <IconsState
                      onDownload={onDownload}
                      onPreview={undefined}
                      keys={keys}
                      msg={packages.find((p) => p.Id === pack.Id) ?? pack}
                      showCaseIcon={false}
                    />
                  )}
                </div>
              </div>
              {showReceiver && (
                <div className={styles.recWrapper}>
                  {pack?.Receivers && pack.Receivers.length === 1 && (
                    <div
                      className={styles.receivers}
                      ref={singleReceiverRef}
                      onClick={() => setShowReceivers(!showReceivers)}
                    >
                      <span>{t("packages.toLabel")}: </span>
                      {pack.Receivers.map((r) => r.Name ?? r.Email).join(
                        ", ",
                      )}{" "}
                    </div>
                  )}

                  {pack?.Receivers && pack?.Receivers?.length > 1 && (
                    <div className={styles.toList}>
                      <span>{t("packages.toLabel")}: </span>

                      {pack?.Receivers &&
                        pack?.Receivers?.filter((r) => !r.Cc && !r.Bcc).length >
                          0 && (
                          <div className={styles.receiver}>
                            {pack.Receivers.filter((r) => !r.Cc && !r.Bcc)[0]
                              .Name ??
                              pack.Receivers.filter((r) => !r.Cc && !r.Bcc)[0]
                                .Email}
                          </div>
                        )}

                      {pack.Receivers?.filter((r) => !r.Cc && !r.Bcc).length >
                        1 && (
                        <div
                          className={styles.moreReceivers}
                          ref={receiversReference}
                          onClick={() => setShowReceivers(!showReceivers)}
                        >
                          <GroupIcon></GroupIcon> +{" "}
                          {pack.Receivers?.filter((r) => !r.Cc && !r.Bcc)
                            .length - 1}
                        </div>
                      )}

                      {packCcReceivers && packCcReceivers.length > 0 && (
                        <div className={styles.ccList}>
                          <div className={styles.toList}>
                            <div className={styles.tdw}>{t("chat.ccLabel")}:</div>
                            <div className={styles.receiver}>
                              {packCcReceivers[0].Name ??
                                packCcReceivers[0].Email}
                            </div>
                            {packCcReceivers.length > 1 && (
                              <>
                                <div
                                  className={styles.moreReceivers}
                                  ref={receiversCcReference}
                                  onClick={() =>
                                    setShowCcReceivers(!showCcReceivers)
                                  }
                                >
                                  <GroupIcon></GroupIcon> +{" "}
                                  {packCcReceivers.length - 1}
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  <Popper
                    open={showReceivers}
                    anchorEl={
                      singleReceiverRef?.current ?? receiversReference?.current
                    }
                    setOpen={setShowReceivers}
                  >
                    <PackageReceiversModal
                      toggle={() => setShowReceivers(false)}
                      pack={pack}
                      cc={false}
                      caseId={caseId}
                    />
                  </Popper>

                  <Popper
                    open={showCcReceivers}
                    anchorEl={receiversCcReference?.current}
                    setOpen={setShowReceivers}
                  >
                    <PackageReceiversModal
                      toggle={() => setShowCcReceivers(false)}
                      pack={pack}
                      cc={true}
                      caseId={caseId}
                    />
                  </Popper>
                </div>
              )}
              <div className={styles.row3}>
                {expanded && status && (
                  <div
                    onClick={() => {
                      setShowFlags(!showFlags);
                    }}
                    ref={statusRef}
                    className={styles.badge}
                  >
                    <StatusBadge small showName={true} status={status} />
                  </div>
                )}
                {expanded && !!findedTags?.length && (
                  <div className={styles.tags}>
                    {findedTags?.map((tag, i) => (
                      <TagBadge
                        key={i}
                        onRemove={(tag) => handleRemoveTag(tag)}
                        tag={tag}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
          {!forceExpanded && (
            <div
              onClick={() => {
                setExpanded(!expanded);
              }}
              className={styles.expander}
            >
              <div className={styles.expandButton}>
                {expanded ? t("common.collapse") : t("common.expand")}
                <FontAwesomeIcon icon={expanded ? faAngleUp : faAngleDown} />
              </div>
            </div>
          )}
          {expanded && (
            <div className={styles.borderLine}>
              <div className={styles.line}></div>
            </div>
          )}
          {!setPack && expanded && !forceExpanded && (
            <FontAwesomeIcon
              className={styles.expander}
              onClick={() => {
                if (setPack) return;
                setExpanded(!expanded);
              }}
              icon={faEllipsis}
            />
          )}

          <div className={styles.body}>
            {!expanded && status && (
              <div className={styles.badgesWrapper}>
                {status && (
                  <div
                    onClick={(e) => {
                      setShowFlags(!showFlags);
                      e.stopPropagation();
                    }}
                    ref={statusRef}
                    className={styles.badge}
                  >
                    {/* <StatusBadge onRemove={() => {}} status={status} /> */}
                  </div>
                )}
              </div>
            )}
            {!expanded && !!findedTags?.length && (
              <div className={styles.tags}>
                {findedTags?.map((tag, i) => (
                  <TagBadge
                    key={i}
                    onRemove={(tag) => handleRemoveTag(tag)}
                    tag={tag}
                  />
                ))}
              </div>
            )}
          </div>
          {expanded && (
            <>
              <div
                className={styles.lead}
                dangerouslySetInnerHTML={{
                  __html:
                    content !==
                    "<html><head></head><body>undefined</body></html>"
                      ? sanitizeUserHtml(content)
                      : "",
                }}
                onClick={() => {
                  if (setPack) return;
                  // setExpanded(!expanded);
                }}
              ></div>
              <div className={styles.attachments}>
                {pack.Attachments?.map((attachment) => (
                  <div className={styles.attach} key={"att2_" + attachment.Id}>
                    <PackageAttachment
                      key={"att_" + attachment.Id}
                      onAddDossier={handleAddToDossierClick}
                      date={moment(pack.ReceiveDate ?? pack.CreationDate)
                        .format("HH:MM | DD.MM.YYYY")
                        .toString()}
                      onNewWindow={onNewWindow}
                      onPreview={(attach) => {
                        if (onPreview) {
                          onPreview(pack, attach);
                          return;
                        }

                        const isFullScreen =
                          window.location.href.search("fullscreen") !== -1;

                        const query = new URLSearchParams(
                          window.location.search,
                        );

                        if (isFullScreen && !query.get("fullscreen")) {
                          query.append("fullscreen", "1");
                        }

                        query.append(
                          "pdf",
                          `${pack.Id}:${attach.FileName.replace(":", "")}:${
                            attach.Uri ?? attach.Id
                          }:${attach.Kind}:${attach.EncryptionKeyId}`,
                        );

                        navigate(`${window.location.pathname}?${query}`);
                      }}
                      onDownload={(attach) => onDownload(pack, attach)}
                      attachment={attachment}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
          {/* {!setPack && (
            <div>
              <FontAwesomeIcon
                className={styles.expander}
                onClick={() => {
                  if (setPack) return;
                }}
                icon={faEllipsis}
              />
            </div>
          )} */}
          {showFlags && (
            <ModalLayout customX={0} customY={-30} refWrapper={statusRef}>
              <StatusModal
                toggle={setShowFlags}
                item={pack}
                selectedStatus={status}
              />
            </ModalLayout>
          )}
          {showDossier && (
            <>
              {attachmentsLocation === "center" && (
                <ModalLayout dock={DockPosition.CENTER} showBg={true}>
                  <AttachToCaseModalAttachments
                    toggle={(c) => setShowDossier(c)}
                    c={pack.Case}
                    pack={pack}
                    unusedAttachments={unusedAttachments}
                    setUnusedAttachments={setUnusedAttachments}
                    setUsedAttachments={setUsedAttachments}
                    usedAttachments={usedAttachments}
                    onSave={handleDossierSave}
                    position="center"
                  ></AttachToCaseModalAttachments>
                </ModalLayout>
              )}
              {attachmentsLocation !== "center" && (
                <ModalLayout
                  dock={DockPosition.DISABLED}
                  off={true}
                  customX={8}
                  customY={0}
                  ignore
                  isAnimation
                  fullHeight={true}
                  name="attachCase"
                >
                  <div className={styles.leftModal}>
                    <AttachToCaseModalAttachments
                      toggle={(c) => setShowDossier(c)}
                      c={pack.Case}
                      pack={pack}
                      unusedAttachments={unusedAttachments}
                      setUnusedAttachments={setUnusedAttachments}
                      setUsedAttachments={setUsedAttachments}
                      usedAttachments={usedAttachments}
                      onSave={handleDossierSave}
                      className={styles.nomodal}
                      position="left"
                    ></AttachToCaseModalAttachments>
                  </div>
                </ModalLayout>
              )}
            </>
          )}

          <Popper
            open={showDateMetric}
            anchorEl={dateRef?.current}
            setOpen={setShowDateMetic}
          >
            <MetricDatesModal toggle={setShowDateMetic} pack={pack} />
          </Popper>
        </div>
      </div>
    </>
  );
};

export default ChatCard;
